// ==================== 进销存系统 Mock 数据 ====================
// 模拟后端 API 返回数据，开发阶段使用

// ========== 基础资料 ==========

export const mockProducts: any[] = [
  {
    id: 1,
    productCode: "P001",
    productName: "笔记本电脑 Pro 15",
    barcode: "6901234500011",
    categoryId: 1,
    categoryName: "电子产品",
    brandName: "TechBrand",
    spec: "15寸/i7/16G/512G",
    model: "TB-P15",
    unitName: "台",
    purchasePrice: 4500,
    salePrice: 5999,
    retailPrice: 6299,
    minStock: 10,
    maxStock: 200,
    taxRate: 13,
    weight: 2.1,
    status: "enabled",
    createdAt: "2026-01-15 09:30:00",
    updatedAt: "2026-07-20 14:00:00",
  },
  {
    id: 2,
    productCode: "P002",
    productName: "无线鼠标 M200",
    barcode: "6901234500028",
    categoryId: 1,
    categoryName: "电子产品",
    brandName: "TechBrand",
    spec: "2.4G无线/静音",
    model: "M200",
    unitName: "个",
    purchasePrice: 35,
    salePrice: 69,
    retailPrice: 89,
    minStock: 50,
    maxStock: 500,
    taxRate: 13,
    weight: 0.12,
    status: "enabled",
    createdAt: "2026-01-15 09:35:00",
    updatedAt: "2026-06-10 10:00:00",
  },
  {
    id: 3,
    productCode: "P003",
    productName: "机械键盘 K870",
    barcode: "6901234500035",
    categoryId: 1,
    categoryName: "电子产品",
    brandName: "TechBrand",
    spec: "青轴/RGB背光/87键",
    model: "K870",
    unitName: "把",
    purchasePrice: 180,
    salePrice: 329,
    retailPrice: 399,
    minStock: 20,
    maxStock: 300,
    taxRate: 13,
    weight: 0.95,
    status: "enabled",
    createdAt: "2026-02-01 10:00:00",
    updatedAt: "2026-07-15 16:30:00",
  },
  {
    id: 4,
    productCode: "P004",
    productName: "27寸4K显示器",
    barcode: "6901234500042",
    categoryId: 1,
    categoryName: "电子产品",
    brandName: "ViewMax",
    spec: "27寸/4K/IPS/Type-C",
    model: "VM-274K",
    unitName: "台",
    purchasePrice: 1200,
    salePrice: 1899,
    retailPrice: 2199,
    minStock: 5,
    maxStock: 100,
    taxRate: 13,
    weight: 5.5,
    status: "enabled",
    createdAt: "2026-02-10 11:00:00",
    updatedAt: "2026-07-01 09:00:00",
  },
  {
    id: 5,
    productCode: "P005",
    productName: "USB-C 扩展坞",
    barcode: "6901234500059",
    categoryId: 1,
    categoryName: "电子产品",
    brandName: "TechBrand",
    spec: "8合1/4K HDMI",
    model: "UC-08",
    unitName: "个",
    purchasePrice: 85,
    salePrice: 169,
    retailPrice: 199,
    minStock: 30,
    maxStock: 400,
    taxRate: 13,
    weight: 0.2,
    status: "enabled",
    createdAt: "2026-02-20 14:00:00",
    updatedAt: "2026-07-18 11:00:00",
  },
  {
    id: 6,
    productCode: "P006",
    productName: "A4打印纸 80g",
    barcode: "6901234500066",
    categoryId: 2,
    categoryName: "办公耗材",
    brandName: "PaperPro",
    spec: "500张/包",
    model: "A4-80G",
    unitName: "箱",
    purchasePrice: 120,
    salePrice: 168,
    retailPrice: 198,
    minStock: 20,
    maxStock: 500,
    taxRate: 13,
    weight: 12,
    status: "enabled",
    createdAt: "2026-03-01 09:00:00",
    updatedAt: "2026-06-25 15:00:00",
  },
  {
    id: 7,
    productCode: "P007",
    productName: "中性笔 0.5mm 黑色",
    barcode: "6901234500073",
    categoryId: 2,
    categoryName: "办公耗材",
    brandName: "WriteWell",
    spec: "0.5mm/黑色/12支装",
    model: "BP-05B",
    unitName: "盒",
    purchasePrice: 8,
    salePrice: 15,
    retailPrice: 20,
    minStock: 100,
    maxStock: 1000,
    taxRate: 13,
    weight: 0.15,
    status: "enabled",
    createdAt: "2026-03-05 10:00:00",
    updatedAt: "2026-06-20 14:00:00",
  },
  {
    id: 8,
    productCode: "P008",
    productName: "办公椅 人体工学",
    barcode: "6901234500080",
    categoryId: 3,
    categoryName: "办公家具",
    brandName: "ComfortSeat",
    spec: "网布/可调节扶手",
    model: "CS-E200",
    unitName: "把",
    purchasePrice: 450,
    salePrice: 799,
    retailPrice: 999,
    minStock: 5,
    maxStock: 100,
    taxRate: 13,
    weight: 15,
    status: "enabled",
    createdAt: "2026-03-10 11:00:00",
    updatedAt: "2026-07-22 10:00:00",
  },
  {
    id: 9,
    productCode: "P009",
    productName: "文件柜 三抽",
    barcode: "6901234500097",
    categoryId: 3,
    categoryName: "办公家具",
    brandName: "SteelWork",
    spec: "铁制/三抽/带锁",
    model: "SW-FC3",
    unitName: "个",
    purchasePrice: 380,
    salePrice: 599,
    retailPrice: 729,
    minStock: 3,
    maxStock: 50,
    taxRate: 13,
    weight: 25,
    status: "enabled",
    createdAt: "2026-03-15 09:30:00",
    updatedAt: "2026-06-30 16:00:00",
  },
  {
    id: 10,
    productCode: "P010",
    productName: "白板 90x120cm",
    barcode: "6901234500103",
    categoryId: 3,
    categoryName: "办公家具",
    brandName: "BoardPlus",
    spec: "磁性白板/铝合金边框",
    model: "BP-9012",
    unitName: "块",
    purchasePrice: 150,
    salePrice: 268,
    retailPrice: 328,
    minStock: 5,
    maxStock: 80,
    taxRate: 13,
    weight: 6,
    status: "enabled",
    createdAt: "2026-04-01 10:00:00",
    updatedAt: "2026-07-05 11:30:00",
  },
  {
    id: 11,
    productCode: "P011",
    productName: "网线 CAT6 5米",
    barcode: "6901234500110",
    categoryId: 1,
    categoryName: "电子产品",
    brandName: "NetLink",
    spec: "CAT6/5米/蓝色",
    model: "NL-C6-5",
    unitName: "根",
    purchasePrice: 12,
    salePrice: 25,
    retailPrice: 35,
    minStock: 50,
    maxStock: 800,
    taxRate: 13,
    weight: 0.2,
    status: "enabled",
    createdAt: "2026-04-10 09:00:00",
    updatedAt: "2026-07-10 14:00:00",
  },
  {
    id: 12,
    productCode: "P012",
    productName: "智能插座 WiFi",
    barcode: "6901234500127",
    categoryId: 1,
    categoryName: "电子产品",
    brandName: "SmartHome",
    spec: "WiFi/定时/电量统计",
    model: "SH-SP01",
    unitName: "个",
    purchasePrice: 45,
    salePrice: 89,
    retailPrice: 109,
    minStock: 30,
    maxStock: 500,
    taxRate: 13,
    weight: 0.15,
    status: "disabled",
    createdAt: "2026-04-15 10:00:00",
    updatedAt: "2026-06-15 15:00:00",
  },
];

export const mockCategories: any[] = [
  {
    id: 1,
    categoryCode: "CAT001",
    categoryName: "电子产品",
    parentId: 0,
    sort: 1,
    level: 1,
    status: "enabled",
  },
  {
    id: 2,
    categoryCode: "CAT002",
    categoryName: "办公耗材",
    parentId: 0,
    sort: 2,
    level: 1,
    status: "enabled",
  },
  {
    id: 3,
    categoryCode: "CAT003",
    categoryName: "办公家具",
    parentId: 0,
    sort: 3,
    level: 1,
    status: "enabled",
  },
  {
    id: 4,
    categoryCode: "CAT004",
    categoryName: "电脑配件",
    parentId: 1,
    sort: 1,
    level: 2,
    status: "enabled",
  },
  {
    id: 5,
    categoryCode: "CAT005",
    categoryName: "网络设备",
    parentId: 1,
    sort: 2,
    level: 2,
    status: "enabled",
  },
];

export const mockWarehouses: any[] = [
  {
    id: 1,
    warehouseCode: "WH001",
    warehouseName: "总部仓库",
    type: "main",
    address: "上海市浦东新区张江高科",
    manager: "张明",
    phone: "13800138001",
    status: "enabled",
    createdAt: "2026-01-01 00:00:00",
  },
  {
    id: 2,
    warehouseCode: "WH002",
    warehouseName: "北京分仓",
    type: "branch",
    address: "北京市朝阳区科技园",
    manager: "李华",
    phone: "13800138002",
    status: "enabled",
    createdAt: "2026-01-01 00:00:00",
  },
  {
    id: 3,
    warehouseCode: "WH003",
    warehouseName: "广州分仓",
    type: "branch",
    address: "广州市天河区软件园",
    manager: "王芳",
    phone: "13800138003",
    status: "enabled",
    createdAt: "2026-01-01 00:00:00",
  },
  {
    id: 4,
    warehouseCode: "WH004",
    warehouseName: "退货仓",
    type: "return",
    address: "上海市浦东新区张江高科",
    manager: "赵伟",
    phone: "13800138004",
    status: "enabled",
    createdAt: "2026-01-01 00:00:00",
  },
];

export const mockCustomers: any[] = [
  {
    id: 1,
    customerCode: "C001",
    customerName: "上海科技有限公司",
    contactPerson: "陈总",
    phone: "13900001001",
    email: "chen@techco.com",
    address: "上海市黄浦区南京东路100号",
    creditLimit: 500000,
    creditUsed: 120000,
    creditBalance: 380000,
    level: "VIP",
    settlementMethod: "月结30天",
    status: "enabled",
    createdAt: "2026-01-05 10:00:00",
  },
  {
    id: 2,
    customerCode: "C002",
    customerName: "北京贸易集团",
    contactPerson: "刘经理",
    phone: "13900001002",
    email: "liu@tradegroup.com",
    address: "北京市西城区西单北街200号",
    creditLimit: 800000,
    creditUsed: 350000,
    creditBalance: 450000,
    level: "VIP",
    settlementMethod: "月结60天",
    status: "enabled",
    createdAt: "2026-01-08 11:00:00",
  },
  {
    id: 3,
    customerCode: "C003",
    customerName: "广州零售连锁",
    contactPerson: "黄总监",
    phone: "13900001003",
    email: "huang@retailchain.com",
    address: "广州市越秀区中山三路50号",
    creditLimit: 300000,
    creditUsed: 280000,
    creditBalance: 20000,
    level: "A",
    settlementMethod: "月结15天",
    status: "enabled",
    createdAt: "2026-01-10 09:00:00",
  },
  {
    id: 4,
    customerCode: "C004",
    customerName: "深圳创新科技",
    contactPerson: "周总",
    phone: "13900001004",
    email: "zhou@innovtech.com",
    address: "深圳市南山区科技园南区",
    creditLimit: 200000,
    creditUsed: 0,
    creditBalance: 200000,
    level: "B",
    settlementMethod: "款到发货",
    status: "enabled",
    createdAt: "2026-02-01 14:00:00",
  },
  {
    id: 5,
    customerCode: "C005",
    customerName: "杭州电商企业",
    contactPerson: "吴经理",
    phone: "13900001005",
    email: "wu@ecommerce.com",
    address: "杭州市西湖区文三路100号",
    creditLimit: 150000,
    creditUsed: 89000,
    creditBalance: 61000,
    level: "B",
    settlementMethod: "月结30天",
    status: "enabled",
    createdAt: "2026-02-15 10:00:00",
  },
  {
    id: 6,
    customerCode: "C006",
    customerName: "成都批发商",
    contactPerson: "孙总",
    phone: "13900001006",
    email: "sun@wholesale.com",
    address: "成都市武侯区天府大道300号",
    creditLimit: 100000,
    creditUsed: 45000,
    creditBalance: 55000,
    level: "C",
    settlementMethod: "款到发货",
    status: "disabled",
    createdAt: "2026-03-01 09:00:00",
  },
];

export const mockSuppliers: any[] = [
  {
    id: 1,
    supplierCode: "S001",
    supplierName: "深圳电子制造有限公司",
    contactPerson: "马总",
    phone: "13700001001",
    email: "ma@szemfg.com",
    address: "深圳市宝安区西乡街道",
    bankName: "招商银行",
    bankAccount: "6225-0000-1234-5678",
    paymentTerms: "月结30天",
    status: "enabled",
    createdAt: "2026-01-03 10:00:00",
  },
  {
    id: 2,
    supplierCode: "S002",
    supplierName: "广东办公用品公司",
    contactPerson: "胡经理",
    phone: "13700001002",
    email: "hu@gdoffice.com",
    address: "广州市番禺区大石街",
    bankName: "工商银行",
    bankAccount: "6222-0000-2345-6789",
    paymentTerms: "月结45天",
    status: "enabled",
    createdAt: "2026-01-05 11:00:00",
  },
  {
    id: 3,
    supplierCode: "S003",
    supplierName: "浙江家具厂",
    contactPerson: "林总",
    phone: "13700001003",
    email: "lin@zjfurniture.com",
    address: "杭州市余杭区仓前街道",
    bankName: "建设银行",
    bankAccount: "6217-0000-3456-7890",
    paymentTerms: "款到发货",
    status: "enabled",
    createdAt: "2026-01-08 09:00:00",
  },
  {
    id: 4,
    supplierCode: "S004",
    supplierName: "江苏线缆科技",
    contactPerson: "高经理",
    phone: "13700001004",
    email: "gao@jscable.com",
    address: "苏州市工业园区星湖街",
    bankName: "中国银行",
    bankAccount: "6216-0000-4567-8901",
    paymentTerms: "月结15天",
    status: "enabled",
    createdAt: "2026-02-01 14:00:00",
  },
  {
    id: 5,
    supplierCode: "S005",
    supplierName: "山东五金制品",
    contactPerson: "罗总",
    phone: "13700001005",
    email: "luo@sdhardware.com",
    address: "济南市历下区经十路",
    bankName: "农业银行",
    bankAccount: "6228-0000-5678-9012",
    paymentTerms: "货到付款",
    status: "enabled",
    createdAt: "2026-02-20 10:00:00",
  },
];

export const mockUnits: any[] = [
  { id: 1, unitCode: "U001", unitName: "个", status: "enabled" },
  { id: 2, unitCode: "U002", unitName: "台", status: "enabled" },
  { id: 3, unitCode: "U003", unitName: "把", status: "enabled" },
  { id: 4, unitCode: "U004", unitName: "箱", status: "enabled" },
  { id: 5, unitCode: "U005", unitName: "盒", status: "enabled" },
  { id: 6, unitCode: "U006", unitName: "根", status: "enabled" },
  { id: 7, unitCode: "U007", unitName: "块", status: "enabled" },
  { id: 8, unitCode: "U008", unitName: "包", status: "enabled" },
];

export const mockBrands: any[] = [
  { id: 1, brandCode: "B001", brandName: "TechBrand", status: "enabled" },
  { id: 2, brandCode: "B002", brandName: "ViewMax", status: "enabled" },
  { id: 3, brandCode: "B003", brandName: "PaperPro", status: "enabled" },
  { id: 4, brandCode: "B004", brandName: "WriteWell", status: "enabled" },
  { id: 5, brandCode: "B005", brandName: "ComfortSeat", status: "enabled" },
  { id: 6, brandCode: "B006", brandName: "SteelWork", status: "enabled" },
  { id: 7, brandCode: "B007", brandName: "NetLink", status: "enabled" },
  { id: 8, brandCode: "B008", brandName: "SmartHome", status: "enabled" },
];

// ========== 采购业务 ==========

export const mockPurchaseOrders: any[] = [
  {
    id: 1,
    orderNo: "PO202601010001",
    supplierId: 1,
    supplierName: "深圳电子制造有限公司",
    warehouseId: 1,
    warehouseName: "总部仓库",
    orderDate: "2026-01-10",
    expectedDate: "2026-01-20",
    totalAmount: 63000,
    totalTax: 8190,
    totalAmountWithTax: 71190,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-01-10 09:00:00",
    items: [
      {
        id: 1,
        orderId: 1,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        spec: "15寸/i7/16G/512G",
        unitName: "台",
        quantity: 10,
        receivedQuantity: 10,
        purchasePrice: 4500,
        taxRate: 13,
        amount: 45000,
        taxAmount: 5850,
        amountWithTax: 50850,
      },
      {
        id: 2,
        orderId: 1,
        productId: 2,
        productCode: "P002",
        productName: "无线鼠标 M200",
        spec: "2.4G无线/静音",
        unitName: "个",
        quantity: 200,
        receivedQuantity: 200,
        purchasePrice: 35,
        taxRate: 13,
        amount: 7000,
        taxAmount: 910,
        amountWithTax: 7910,
      },
      {
        id: 3,
        orderId: 1,
        productId: 3,
        productCode: "P003",
        productName: "机械键盘 K870",
        spec: "青轴/RGB背光/87键",
        unitName: "把",
        quantity: 50,
        receivedQuantity: 50,
        purchasePrice: 180,
        taxRate: 13,
        amount: 9000,
        taxAmount: 1170,
        amountWithTax: 10170,
      },
    ],
  },
  {
    id: 2,
    orderNo: "PO202602050002",
    supplierId: 2,
    supplierName: "广东办公用品公司",
    warehouseId: 1,
    warehouseName: "总部仓库",
    orderDate: "2026-02-05",
    expectedDate: "2026-02-15",
    totalAmount: 28000,
    totalTax: 3640,
    totalAmountWithTax: 31640,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-02-05 10:00:00",
    items: [
      {
        id: 4,
        orderId: 2,
        productId: 6,
        productCode: "P006",
        productName: "A4打印纸 80g",
        spec: "500张/包",
        unitName: "箱",
        quantity: 100,
        receivedQuantity: 100,
        purchasePrice: 120,
        taxRate: 13,
        amount: 12000,
        taxAmount: 1560,
        amountWithTax: 13560,
      },
      {
        id: 5,
        orderId: 2,
        productId: 7,
        productCode: "P007",
        productName: "中性笔 0.5mm 黑色",
        spec: "0.5mm/黑色/12支装",
        unitName: "盒",
        quantity: 2000,
        receivedQuantity: 2000,
        purchasePrice: 8,
        taxRate: 13,
        amount: 16000,
        taxAmount: 2080,
        amountWithTax: 18080,
      },
    ],
  },
  {
    id: 3,
    orderNo: "PO202603200003",
    supplierId: 1,
    supplierName: "深圳电子制造有限公司",
    warehouseId: 2,
    warehouseName: "北京分仓",
    orderDate: "2026-03-20",
    expectedDate: "2026-03-30",
    totalAmount: 51000,
    totalTax: 6630,
    totalAmountWithTax: 57630,
    status: "approved",
    createdBy: "admin",
    createdAt: "2026-03-20 14:00:00",
    items: [
      {
        id: 6,
        orderId: 3,
        productId: 4,
        productCode: "P004",
        productName: "27寸4K显示器",
        spec: "27寸/4K/IPS/Type-C",
        unitName: "台",
        quantity: 30,
        receivedQuantity: 0,
        purchasePrice: 1200,
        taxRate: 13,
        amount: 36000,
        taxAmount: 4680,
        amountWithTax: 40680,
      },
      {
        id: 7,
        orderId: 3,
        productId: 5,
        productCode: "P005",
        productName: "USB-C 扩展坞",
        spec: "8合1/4K HDMI",
        unitName: "个",
        quantity: 100,
        receivedQuantity: 0,
        purchasePrice: 85,
        taxRate: 13,
        amount: 8500,
        taxAmount: 1105,
        amountWithTax: 9605,
      },
      {
        id: 8,
        orderId: 3,
        productId: 11,
        productCode: "P011",
        productName: "网线 CAT6 5米",
        spec: "CAT6/5米/蓝色",
        unitName: "根",
        quantity: 500,
        receivedQuantity: 0,
        purchasePrice: 12,
        taxRate: 13,
        amount: 6000,
        taxAmount: 780,
        amountWithTax: 6780,
      },
    ],
  },
  {
    id: 4,
    orderNo: "PO202604150004",
    supplierId: 3,
    supplierName: "浙江家具厂",
    warehouseId: 1,
    warehouseName: "总部仓库",
    orderDate: "2026-04-15",
    expectedDate: "2026-04-25",
    totalAmount: 31500,
    totalTax: 4095,
    totalAmountWithTax: 35595,
    status: "approved",
    createdBy: "admin",
    createdAt: "2026-04-15 09:30:00",
    items: [
      {
        id: 9,
        orderId: 4,
        productId: 8,
        productCode: "P008",
        productName: "办公椅 人体工学",
        spec: "网布/可调节扶手",
        unitName: "把",
        quantity: 50,
        receivedQuantity: 30,
        purchasePrice: 450,
        taxRate: 13,
        amount: 22500,
        taxAmount: 2925,
        amountWithTax: 25425,
      },
      {
        id: 10,
        orderId: 4,
        productId: 9,
        productCode: "P009",
        productName: "文件柜 三抽",
        spec: "铁制/三抽/带锁",
        unitName: "个",
        quantity: 20,
        receivedQuantity: 15,
        purchasePrice: 380,
        taxRate: 13,
        amount: 7600,
        taxAmount: 988,
        amountWithTax: 8588,
      },
      {
        id: 11,
        orderId: 4,
        productId: 10,
        productCode: "P010",
        productName: "白板 90x120cm",
        spec: "磁性白板/铝合金边框",
        unitName: "块",
        quantity: 10,
        receivedQuantity: 5,
        purchasePrice: 140,
        taxRate: 13,
        amount: 1400,
        taxAmount: 182,
        amountWithTax: 1582,
      },
    ],
  },
  {
    id: 5,
    orderNo: "PO202606010005",
    supplierId: 4,
    supplierName: "江苏线缆科技",
    warehouseId: 3,
    warehouseName: "广州分仓",
    orderDate: "2026-06-01",
    expectedDate: "2026-06-10",
    totalAmount: 12000,
    totalTax: 1560,
    totalAmountWithTax: 13560,
    status: "draft",
    createdBy: "admin",
    createdAt: "2026-06-01 11:00:00",
    items: [
      {
        id: 12,
        orderId: 5,
        productId: 11,
        productCode: "P011",
        productName: "网线 CAT6 5米",
        spec: "CAT6/5米/蓝色",
        unitName: "根",
        quantity: 1000,
        receivedQuantity: 0,
        purchasePrice: 12,
        taxRate: 13,
        amount: 12000,
        taxAmount: 1560,
        amountWithTax: 13560,
      },
    ],
  },
  {
    id: 6,
    orderNo: "PO202607100006",
    supplierId: 1,
    supplierName: "深圳电子制造有限公司",
    warehouseId: 1,
    warehouseName: "总部仓库",
    orderDate: "2026-07-10",
    expectedDate: "2026-07-20",
    totalAmount: 85500,
    totalTax: 11115,
    totalAmountWithTax: 96615,
    status: "in_progress",
    createdBy: "admin",
    createdAt: "2026-07-10 14:00:00",
    items: [
      {
        id: 13,
        orderId: 6,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        spec: "15寸/i7/16G/512G",
        unitName: "台",
        quantity: 15,
        receivedQuantity: 10,
        purchasePrice: 4500,
        taxRate: 13,
        amount: 67500,
        taxAmount: 8775,
        amountWithTax: 76275,
      },
      {
        id: 14,
        orderId: 6,
        productId: 3,
        productCode: "P003",
        productName: "机械键盘 K870",
        spec: "青轴/RGB背光/87键",
        unitName: "把",
        quantity: 100,
        receivedQuantity: 50,
        purchasePrice: 180,
        taxRate: 13,
        amount: 18000,
        taxAmount: 2340,
        amountWithTax: 20340,
      },
    ],
  },
];

export const mockPurchaseReceipts: any[] = [
  {
    id: 1,
    receiptNo: "PR202601150001",
    orderId: 1,
    orderNo: "PO202601010001",
    supplierId: 1,
    supplierName: "深圳电子制造有限公司",
    warehouseId: 1,
    warehouseName: "总部仓库",
    receiptDate: "2026-01-15",
    totalAmount: 63000,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-01-15 10:00:00",
    items: [
      {
        id: 1,
        receiptId: 1,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        quantity: 10,
        purchasePrice: 4500,
        amount: 45000,
        batchNo: "B20260115001",
      },
      {
        id: 2,
        receiptId: 1,
        productId: 2,
        productCode: "P002",
        productName: "无线鼠标 M200",
        quantity: 200,
        purchasePrice: 35,
        amount: 7000,
        batchNo: "B20260115002",
      },
      {
        id: 3,
        receiptId: 1,
        productId: 3,
        productCode: "P003",
        productName: "机械键盘 K870",
        quantity: 50,
        purchasePrice: 180,
        amount: 9000,
        batchNo: "B20260115003",
      },
    ],
  },
  {
    id: 2,
    receiptNo: "PR202602100002",
    orderId: 2,
    orderNo: "PO202602050002",
    supplierId: 2,
    supplierName: "广东办公用品公司",
    warehouseId: 1,
    warehouseName: "总部仓库",
    receiptDate: "2026-02-10",
    totalAmount: 28000,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-02-10 09:00:00",
    items: [
      {
        id: 4,
        receiptId: 2,
        productId: 6,
        productCode: "P006",
        productName: "A4打印纸 80g",
        quantity: 100,
        purchasePrice: 120,
        amount: 12000,
        batchNo: "B20260210001",
      },
      {
        id: 5,
        receiptId: 2,
        productId: 7,
        productCode: "P007",
        productName: "中性笔 0.5mm 黑色",
        quantity: 2000,
        purchasePrice: 8,
        amount: 16000,
        batchNo: "B20260210002",
      },
    ],
  },
  {
    id: 3,
    receiptNo: "PR202604200003",
    orderId: 4,
    orderNo: "PO202604150004",
    supplierId: 3,
    supplierName: "浙江家具厂",
    warehouseId: 1,
    warehouseName: "总部仓库",
    receiptDate: "2026-04-20",
    totalAmount: 18900,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-04-20 14:00:00",
    items: [
      {
        id: 6,
        receiptId: 3,
        productId: 8,
        productCode: "P008",
        productName: "办公椅 人体工学",
        quantity: 30,
        purchasePrice: 450,
        amount: 13500,
        batchNo: "B20260420001",
      },
      {
        id: 7,
        receiptId: 3,
        productId: 9,
        productCode: "P009",
        productName: "文件柜 三抽",
        quantity: 15,
        purchasePrice: 380,
        amount: 5700,
        batchNo: "B20260420002",
      },
    ],
  },
  {
    id: 4,
    receiptNo: "PR202607150004",
    orderId: 6,
    orderNo: "PO202607100006",
    supplierId: 1,
    supplierName: "深圳电子制造有限公司",
    warehouseId: 1,
    warehouseName: "总部仓库",
    receiptDate: "2026-07-15",
    totalAmount: 54000,
    status: "approved",
    createdBy: "admin",
    createdAt: "2026-07-15 10:00:00",
    items: [
      {
        id: 8,
        receiptId: 4,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        quantity: 10,
        purchasePrice: 4500,
        amount: 45000,
        batchNo: "B20260715001",
      },
      {
        id: 9,
        receiptId: 4,
        productId: 3,
        productCode: "P003",
        productName: "机械键盘 K870",
        quantity: 50,
        purchasePrice: 180,
        amount: 9000,
        batchNo: "B20260715002",
      },
    ],
  },
];

// ========== 销售业务 ==========

export const mockSalesOrders: any[] = [
  {
    id: 1,
    orderNo: "SO202601200001",
    customerId: 1,
    customerName: "上海科技有限公司",
    warehouseId: 1,
    warehouseName: "总部仓库",
    orderDate: "2026-01-20",
    deliveryDate: "2026-01-25",
    totalAmount: 65000,
    totalTax: 8450,
    totalAmountWithTax: 73450,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-01-20 10:00:00",
    items: [
      {
        id: 1,
        orderId: 1,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        spec: "15寸/i7/16G/512G",
        unitName: "台",
        quantity: 5,
        deliveredQuantity: 5,
        salePrice: 5999,
        taxRate: 13,
        amount: 29995,
        taxAmount: 3899,
        amountWithTax: 33894,
      },
      {
        id: 2,
        orderId: 1,
        productId: 4,
        productCode: "P004",
        productName: "27寸4K显示器",
        spec: "27寸/4K/IPS/Type-C",
        unitName: "台",
        quantity: 10,
        deliveredQuantity: 10,
        salePrice: 1899,
        taxRate: 13,
        amount: 18990,
        taxAmount: 2469,
        amountWithTax: 21459,
      },
      {
        id: 3,
        orderId: 1,
        productId: 3,
        productCode: "P003",
        productName: "机械键盘 K870",
        spec: "青轴/RGB背光/87键",
        unitName: "把",
        quantity: 50,
        deliveredQuantity: 50,
        salePrice: 329,
        taxRate: 13,
        amount: 16450,
        taxAmount: 2139,
        amountWithTax: 18589,
      },
    ],
  },
  {
    id: 2,
    orderNo: "SO202602250002",
    customerId: 2,
    customerName: "北京贸易集团",
    warehouseId: 2,
    warehouseName: "北京分仓",
    orderDate: "2026-02-25",
    deliveryDate: "2026-03-05",
    totalAmount: 89000,
    totalTax: 11570,
    totalAmountWithTax: 100570,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-02-25 11:00:00",
    items: [
      {
        id: 4,
        orderId: 2,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        spec: "15寸/i7/16G/512G",
        unitName: "台",
        quantity: 10,
        deliveredQuantity: 10,
        salePrice: 5999,
        taxRate: 13,
        amount: 59990,
        taxAmount: 7799,
        amountWithTax: 67789,
      },
      {
        id: 5,
        orderId: 2,
        productId: 5,
        productCode: "P005",
        productName: "USB-C 扩展坞",
        spec: "8合1/4K HDMI",
        unitName: "个",
        quantity: 100,
        deliveredQuantity: 100,
        salePrice: 169,
        taxRate: 13,
        amount: 16900,
        taxAmount: 2197,
        amountWithTax: 19097,
      },
      {
        id: 6,
        orderId: 2,
        productId: 2,
        productCode: "P002",
        productName: "无线鼠标 M200",
        spec: "2.4G无线/静音",
        unitName: "个",
        quantity: 100,
        deliveredQuantity: 100,
        salePrice: 69,
        taxRate: 13,
        amount: 6900,
        taxAmount: 897,
        amountWithTax: 7797,
      },
      {
        id: 7,
        orderId: 2,
        productId: 11,
        productCode: "P011",
        productName: "网线 CAT6 5米",
        spec: "CAT6/5米/蓝色",
        unitName: "根",
        quantity: 200,
        deliveredQuantity: 200,
        salePrice: 25,
        taxRate: 13,
        amount: 5000,
        taxAmount: 650,
        amountWithTax: 5650,
      },
    ],
  },
  {
    id: 3,
    orderNo: "SO202604100003",
    customerId: 3,
    customerName: "广州零售连锁",
    warehouseId: 3,
    warehouseName: "广州分仓",
    orderDate: "2026-04-10",
    deliveryDate: "2026-04-15",
    totalAmount: 42500,
    totalTax: 5525,
    totalAmountWithTax: 48025,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-04-10 09:00:00",
    items: [
      {
        id: 8,
        orderId: 3,
        productId: 6,
        productCode: "P006",
        productName: "A4打印纸 80g",
        spec: "500张/包",
        unitName: "箱",
        quantity: 100,
        deliveredQuantity: 100,
        salePrice: 168,
        taxRate: 13,
        amount: 16800,
        taxAmount: 2184,
        amountWithTax: 18984,
      },
      {
        id: 9,
        orderId: 3,
        productId: 7,
        productCode: "P007",
        productName: "中性笔 0.5mm 黑色",
        spec: "0.5mm/黑色/12支装",
        unitName: "盒",
        quantity: 1000,
        deliveredQuantity: 1000,
        salePrice: 15,
        taxRate: 13,
        amount: 15000,
        taxAmount: 1950,
        amountWithTax: 16950,
      },
      {
        id: 10,
        orderId: 3,
        productId: 8,
        productCode: "P008",
        productName: "办公椅 人体工学",
        spec: "网布/可调节扶手",
        unitName: "把",
        quantity: 10,
        deliveredQuantity: 10,
        salePrice: 799,
        taxRate: 13,
        amount: 7990,
        taxAmount: 1039,
        amountWithTax: 9029,
      },
      {
        id: 11,
        orderId: 3,
        productId: 10,
        productCode: "P010",
        productName: "白板 90x120cm",
        spec: "磁性白板/铝合金边框",
        unitName: "块",
        quantity: 10,
        deliveredQuantity: 10,
        salePrice: 268,
        taxRate: 13,
        amount: 2680,
        taxAmount: 348,
        amountWithTax: 3028,
      },
    ],
  },
  {
    id: 4,
    orderNo: "SO202606180004",
    customerId: 4,
    customerName: "深圳创新科技",
    warehouseId: 1,
    warehouseName: "总部仓库",
    orderDate: "2026-06-18",
    deliveryDate: "2026-06-25",
    totalAmount: 59990,
    totalTax: 7799,
    totalAmountWithTax: 67789,
    status: "approved",
    createdBy: "admin",
    createdAt: "2026-06-18 14:00:00",
    items: [
      {
        id: 12,
        orderId: 4,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        spec: "15寸/i7/16G/512G",
        unitName: "台",
        quantity: 10,
        deliveredQuantity: 0,
        salePrice: 5999,
        taxRate: 13,
        amount: 59990,
        taxAmount: 7799,
        amountWithTax: 67789,
      },
    ],
  },
  {
    id: 5,
    orderNo: "SO202607200005",
    customerId: 5,
    customerName: "杭州电商企业",
    warehouseId: 1,
    warehouseName: "总部仓库",
    orderDate: "2026-07-20",
    deliveryDate: "2026-07-25",
    totalAmount: 33800,
    totalTax: 4394,
    totalAmountWithTax: 38194,
    status: "draft",
    createdBy: "admin",
    createdAt: "2026-07-20 10:00:00",
    items: [
      {
        id: 13,
        orderId: 5,
        productId: 2,
        productCode: "P002",
        productName: "无线鼠标 M200",
        spec: "2.4G无线/静音",
        unitName: "个",
        quantity: 200,
        deliveredQuantity: 0,
        salePrice: 69,
        taxRate: 13,
        amount: 13800,
        taxAmount: 1794,
        amountWithTax: 15594,
      },
      {
        id: 14,
        orderId: 5,
        productId: 3,
        productCode: "P003",
        productName: "机械键盘 K870",
        spec: "青轴/RGB背光/87键",
        unitName: "把",
        quantity: 40,
        deliveredQuantity: 0,
        salePrice: 329,
        taxRate: 13,
        amount: 13160,
        taxAmount: 1711,
        amountWithTax: 14871,
      },
      {
        id: 15,
        orderId: 5,
        productId: 5,
        productCode: "P005",
        productName: "USB-C 扩展坞",
        spec: "8合1/4K HDMI",
        unitName: "个",
        quantity: 40,
        deliveredQuantity: 0,
        salePrice: 169,
        taxRate: 13,
        amount: 6760,
        taxAmount: 879,
        amountWithTax: 7639,
      },
    ],
  },
];

export const mockSalesDeliveries: any[] = [
  {
    id: 1,
    deliveryNo: "SD202601250001",
    orderId: 1,
    orderNo: "SO202601200001",
    customerId: 1,
    customerName: "上海科技有限公司",
    warehouseId: 1,
    warehouseName: "总部仓库",
    deliveryDate: "2026-01-25",
    totalAmount: 65000,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-01-25 09:00:00",
    items: [
      {
        id: 1,
        deliveryId: 1,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        quantity: 5,
        salePrice: 5999,
        amount: 29995,
        batchNo: "B20260115001",
      },
      {
        id: 2,
        deliveryId: 1,
        productId: 4,
        productCode: "P004",
        productName: "27寸4K显示器",
        quantity: 10,
        salePrice: 1899,
        amount: 18990,
        batchNo: "B20260301001",
      },
      {
        id: 3,
        deliveryId: 1,
        productId: 3,
        productCode: "P003",
        productName: "机械键盘 K870",
        quantity: 50,
        salePrice: 329,
        amount: 16450,
        batchNo: "B20260115003",
      },
    ],
  },
  {
    id: 2,
    deliveryNo: "SD202603050002",
    orderId: 2,
    orderNo: "SO202602250002",
    customerId: 2,
    customerName: "北京贸易集团",
    warehouseId: 2,
    warehouseName: "北京分仓",
    deliveryDate: "2026-03-05",
    totalAmount: 89000,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-03-05 10:00:00",
    items: [
      {
        id: 4,
        deliveryId: 2,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        quantity: 10,
        salePrice: 5999,
        amount: 59990,
        batchNo: "B20260115001",
      },
      {
        id: 5,
        deliveryId: 2,
        productId: 5,
        productCode: "P005",
        productName: "USB-C 扩展坞",
        quantity: 100,
        salePrice: 169,
        amount: 16900,
      },
      {
        id: 6,
        deliveryId: 2,
        productId: 2,
        productCode: "P002",
        productName: "无线鼠标 M200",
        quantity: 100,
        salePrice: 69,
        amount: 6900,
      },
      {
        id: 7,
        deliveryId: 2,
        productId: 11,
        productCode: "P011",
        productName: "网线 CAT6 5米",
        quantity: 200,
        salePrice: 25,
        amount: 5000,
      },
    ],
  },
  {
    id: 3,
    deliveryNo: "SD202604150003",
    orderId: 3,
    orderNo: "SO202604100003",
    customerId: 3,
    customerName: "广州零售连锁",
    warehouseId: 3,
    warehouseName: "广州分仓",
    deliveryDate: "2026-04-15",
    totalAmount: 42500,
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-04-15 09:00:00",
    items: [
      {
        id: 8,
        deliveryId: 3,
        productId: 6,
        productCode: "P006",
        productName: "A4打印纸 80g",
        quantity: 100,
        salePrice: 168,
        amount: 16800,
      },
      {
        id: 9,
        deliveryId: 3,
        productId: 7,
        productCode: "P007",
        productName: "中性笔 0.5mm 黑色",
        quantity: 1000,
        salePrice: 15,
        amount: 15000,
      },
      {
        id: 10,
        deliveryId: 3,
        productId: 8,
        productCode: "P008",
        productName: "办公椅 人体工学",
        quantity: 10,
        salePrice: 799,
        amount: 7990,
      },
      {
        id: 11,
        deliveryId: 3,
        productId: 10,
        productCode: "P010",
        productName: "白板 90x120cm",
        quantity: 10,
        salePrice: 268,
        amount: 2680,
      },
    ],
  },
];

// ========== 库存数据 ==========

export const mockInventory: any[] = [
  {
    id: 1,
    productId: 1,
    productCode: "P001",
    productName: "笔记本电脑 Pro 15",
    spec: "15寸/i7/16G/512G",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 25,
    lockedQuantity: 10,
    availableQuantity: 15,
    avgCost: 4500,
    totalValue: 112500,
    batchNo: "B20260115001",
  },
  {
    id: 2,
    productId: 2,
    productCode: "P002",
    productName: "无线鼠标 M200",
    spec: "2.4G无线/静音",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 180,
    lockedQuantity: 0,
    availableQuantity: 180,
    avgCost: 35,
    totalValue: 6300,
  },
  {
    id: 3,
    productId: 3,
    productCode: "P003",
    productName: "机械键盘 K870",
    spec: "青轴/RGB背光/87键",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 85,
    lockedQuantity: 0,
    availableQuantity: 85,
    avgCost: 180,
    totalValue: 15300,
  },
  {
    id: 4,
    productId: 4,
    productCode: "P004",
    productName: "27寸4K显示器",
    spec: "27寸/4K/IPS/Type-C",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 15,
    lockedQuantity: 0,
    availableQuantity: 15,
    avgCost: 1200,
    totalValue: 18000,
  },
  {
    id: 5,
    productId: 5,
    productCode: "P005",
    productName: "USB-C 扩展坞",
    spec: "8合1/4K HDMI",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 95,
    lockedQuantity: 0,
    availableQuantity: 95,
    avgCost: 85,
    totalValue: 8075,
  },
  {
    id: 6,
    productId: 6,
    productCode: "P006",
    productName: "A4打印纸 80g",
    spec: "500张/包",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 80,
    lockedQuantity: 0,
    availableQuantity: 80,
    avgCost: 120,
    totalValue: 9600,
  },
  {
    id: 7,
    productId: 7,
    productCode: "P007",
    productName: "中性笔 0.5mm 黑色",
    spec: "0.5mm/黑色/12支装",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 1500,
    lockedQuantity: 0,
    availableQuantity: 1500,
    avgCost: 8,
    totalValue: 12000,
  },
  {
    id: 8,
    productId: 8,
    productCode: "P008",
    productName: "办公椅 人体工学",
    spec: "网布/可调节扶手",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 30,
    lockedQuantity: 0,
    availableQuantity: 30,
    avgCost: 450,
    totalValue: 13500,
  },
  {
    id: 9,
    productId: 9,
    productCode: "P009",
    productName: "文件柜 三抽",
    spec: "铁制/三抽/带锁",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 15,
    lockedQuantity: 0,
    availableQuantity: 15,
    avgCost: 380,
    totalValue: 5700,
  },
  {
    id: 10,
    productId: 10,
    productCode: "P010",
    productName: "白板 90x120cm",
    spec: "磁性白板/铝合金边框",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 8,
    lockedQuantity: 0,
    availableQuantity: 8,
    avgCost: 150,
    totalValue: 1200,
  },
  {
    id: 11,
    productId: 11,
    productCode: "P011",
    productName: "网线 CAT6 5米",
    spec: "CAT6/5米/蓝色",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 350,
    lockedQuantity: 0,
    availableQuantity: 350,
    avgCost: 12,
    totalValue: 4200,
  },
  {
    id: 12,
    productId: 1,
    productCode: "P001",
    productName: "笔记本电脑 Pro 15",
    spec: "15寸/i7/16G/512G",
    warehouseId: 2,
    warehouseName: "北京分仓",
    quantity: 5,
    lockedQuantity: 0,
    availableQuantity: 5,
    avgCost: 4500,
    totalValue: 22500,
  },
  {
    id: 13,
    productId: 2,
    productCode: "P002",
    productName: "无线鼠标 M200",
    spec: "2.4G无线/静音",
    warehouseId: 2,
    warehouseName: "北京分仓",
    quantity: 50,
    lockedQuantity: 0,
    availableQuantity: 50,
    avgCost: 35,
    totalValue: 1750,
  },
  {
    id: 14,
    productId: 6,
    productCode: "P006",
    productName: "A4打印纸 80g",
    spec: "500张/包",
    warehouseId: 3,
    warehouseName: "广州分仓",
    quantity: 30,
    lockedQuantity: 0,
    availableQuantity: 30,
    avgCost: 120,
    totalValue: 3600,
  },
  {
    id: 15,
    productId: 12,
    productCode: "P012",
    productName: "智能插座 WiFi",
    spec: "WiFi/定时/电量统计",
    warehouseId: 1,
    warehouseName: "总部仓库",
    quantity: 60,
    lockedQuantity: 0,
    availableQuantity: 60,
    avgCost: 45,
    totalValue: 2700,
  },
];

export const mockInventoryTransactions: any[] = [
  {
    id: 1,
    transactionNo: "IT202601150001",
    productId: 1,
    productCode: "P001",
    productName: "笔记本电脑 Pro 15",
    warehouseId: 1,
    warehouseName: "总部仓库",
    type: "purchase_in",
    typeName: "采购入库",
    quantity: 10,
    balanceQuantity: 10,
    unitCost: 4500,
    amount: 45000,
    sourceType: "purchase_receipt",
    sourceNo: "PR202601150001",
    createdAt: "2026-01-15 10:00:00",
    createdBy: "admin",
  },
  {
    id: 2,
    transactionNo: "IT202601250001",
    productId: 1,
    productCode: "P001",
    productName: "笔记本电脑 Pro 15",
    warehouseId: 1,
    warehouseName: "总部仓库",
    type: "sale_out",
    typeName: "销售出库",
    quantity: -5,
    balanceQuantity: 5,
    unitCost: 4500,
    amount: -22500,
    sourceType: "sales_delivery",
    sourceNo: "SD202601250001",
    createdAt: "2026-01-25 09:00:00",
    createdBy: "admin",
  },
  {
    id: 3,
    transactionNo: "IT202602100002",
    productId: 6,
    productCode: "P006",
    productName: "A4打印纸 80g",
    warehouseId: 1,
    warehouseName: "总部仓库",
    type: "purchase_in",
    typeName: "采购入库",
    quantity: 100,
    balanceQuantity: 100,
    unitCost: 120,
    amount: 12000,
    sourceType: "purchase_receipt",
    sourceNo: "PR202602100002",
    createdAt: "2026-02-10 09:00:00",
    createdBy: "admin",
  },
  {
    id: 4,
    transactionNo: "IT202603050002",
    productId: 1,
    productCode: "P001",
    productName: "笔记本电脑 Pro 15",
    warehouseId: 2,
    warehouseName: "北京分仓",
    type: "sale_out",
    typeName: "销售出库",
    quantity: -10,
    balanceQuantity: 5,
    unitCost: 4500,
    amount: -45000,
    sourceType: "sales_delivery",
    sourceNo: "SD202603050002",
    createdAt: "2026-03-05 10:00:00",
    createdBy: "admin",
  },
  {
    id: 5,
    transactionNo: "IT202604150003",
    productId: 6,
    productCode: "P006",
    productName: "A4打印纸 80g",
    warehouseId: 3,
    warehouseName: "广州分仓",
    type: "sale_out",
    typeName: "销售出库",
    quantity: -100,
    balanceQuantity: 30,
    unitCost: 120,
    amount: -12000,
    sourceType: "sales_delivery",
    sourceNo: "SD202604150003",
    createdAt: "2026-04-15 09:00:00",
    createdBy: "admin",
  },
  {
    id: 6,
    transactionNo: "IT202604200003",
    productId: 8,
    productCode: "P008",
    productName: "办公椅 人体工学",
    warehouseId: 1,
    warehouseName: "总部仓库",
    type: "purchase_in",
    typeName: "采购入库",
    quantity: 30,
    balanceQuantity: 30,
    unitCost: 450,
    amount: 13500,
    sourceType: "purchase_receipt",
    sourceNo: "PR202604200003",
    createdAt: "2026-04-20 14:00:00",
    createdBy: "admin",
  },
  {
    id: 7,
    transactionNo: "IT202607150004",
    productId: 1,
    productCode: "P001",
    productName: "笔记本电脑 Pro 15",
    warehouseId: 1,
    warehouseName: "总部仓库",
    type: "purchase_in",
    typeName: "采购入库",
    quantity: 10,
    balanceQuantity: 25,
    unitCost: 4500,
    amount: 45000,
    sourceType: "purchase_receipt",
    sourceNo: "PR202607150004",
    createdAt: "2026-07-15 10:00:00",
    createdBy: "admin",
  },
];

export const mockStockTakes: any[] = [
  {
    id: 1,
    takeNo: "ST202603010001",
    warehouseId: 1,
    warehouseName: "总部仓库",
    takeDate: "2026-03-01",
    status: "completed",
    totalItems: 12,
    gainItems: 1,
    lossItems: 2,
    totalGainAmount: 350,
    totalLossAmount: 870,
    createdBy: "admin",
    createdAt: "2026-03-01 09:00:00",
    items: [
      {
        id: 1,
        takeId: 1,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        bookQuantity: 5,
        actualQuantity: 5,
        diffQuantity: 0,
        unitCost: 4500,
        diffAmount: 0,
      },
      {
        id: 2,
        takeId: 1,
        productId: 2,
        productCode: "P002",
        productName: "无线鼠标 M200",
        bookQuantity: 200,
        actualQuantity: 198,
        diffQuantity: -2,
        unitCost: 35,
        diffAmount: -70,
      },
      {
        id: 3,
        takeId: 1,
        productId: 3,
        productCode: "P003",
        productName: "机械键盘 K870",
        bookQuantity: 50,
        actualQuantity: 52,
        diffQuantity: 2,
        unitCost: 180,
        diffAmount: 360,
      },
      {
        id: 4,
        takeId: 1,
        productId: 4,
        productCode: "P004",
        productName: "27寸4K显示器",
        bookQuantity: 15,
        actualQuantity: 13,
        diffQuantity: -2,
        unitCost: 1200,
        diffAmount: -2400,
      },
    ],
  },
  {
    id: 2,
    takeNo: "ST202606010002",
    warehouseId: 2,
    warehouseName: "北京分仓",
    takeDate: "2026-06-01",
    status: "completed",
    totalItems: 8,
    gainItems: 0,
    lossItems: 1,
    totalGainAmount: 0,
    totalLossAmount: 210,
    createdBy: "admin",
    createdAt: "2026-06-01 10:00:00",
    items: [
      {
        id: 5,
        takeId: 2,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        bookQuantity: 5,
        actualQuantity: 5,
        diffQuantity: 0,
        unitCost: 4500,
        diffAmount: 0,
      },
      {
        id: 6,
        takeId: 2,
        productId: 2,
        productCode: "P002",
        productName: "无线鼠标 M200",
        bookQuantity: 50,
        actualQuantity: 44,
        diffQuantity: -6,
        unitCost: 35,
        diffAmount: -210,
      },
    ],
  },
  {
    id: 3,
    takeNo: "ST202607010003",
    warehouseId: 1,
    warehouseName: "总部仓库",
    takeDate: "2026-07-01",
    status: "draft",
    totalItems: 12,
    gainItems: 0,
    lossItems: 0,
    totalGainAmount: 0,
    totalLossAmount: 0,
    createdBy: "admin",
    createdAt: "2026-07-01 09:00:00",
    items: [],
  },
];

export const mockStockTransfers: any[] = [
  {
    id: 1,
    transferNo: "TR202602010001",
    fromWarehouseId: 1,
    fromWarehouseName: "总部仓库",
    toWarehouseId: 2,
    toWarehouseName: "北京分仓",
    transferDate: "2026-02-01",
    status: "completed",
    totalAmount: 27000,
    createdBy: "admin",
    createdAt: "2026-02-01 10:00:00",
    items: [
      {
        id: 1,
        transferId: 1,
        productId: 1,
        productCode: "P001",
        productName: "笔记本电脑 Pro 15",
        quantity: 5,
        unitCost: 4500,
        amount: 22500,
      },
      {
        id: 2,
        transferId: 1,
        productId: 2,
        productCode: "P002",
        productName: "无线鼠标 M200",
        quantity: 100,
        unitCost: 35,
        amount: 3500,
      },
      {
        id: 3,
        transferId: 1,
        productId: 11,
        productCode: "P011",
        productName: "网线 CAT6 5米",
        quantity: 100,
        unitCost: 12,
        amount: 1200,
      },
    ],
  },
  {
    id: 2,
    transferNo: "TR202605010002",
    fromWarehouseId: 1,
    fromWarehouseName: "总部仓库",
    toWarehouseId: 3,
    toWarehouseName: "广州分仓",
    transferDate: "2026-05-01",
    status: "completed",
    totalAmount: 14400,
    createdBy: "admin",
    createdAt: "2026-05-01 11:00:00",
    items: [
      {
        id: 4,
        transferId: 2,
        productId: 6,
        productCode: "P006",
        productName: "A4打印纸 80g",
        quantity: 100,
        unitCost: 120,
        amount: 12000,
      },
      {
        id: 5,
        transferId: 2,
        productId: 7,
        productCode: "P007",
        productName: "中性笔 0.5mm 黑色",
        quantity: 300,
        unitCost: 8,
        amount: 2400,
      },
    ],
  },
];

// ========== 资金管理 ==========

export const mockAccounts: any[] = [
  {
    id: 1,
    accountCode: "AC001",
    accountName: "招商银行基本户",
    type: "bank",
    typeName: "银行账户",
    balance: 1250000,
    bankName: "招商银行",
    bankAccount: "6225-0000-1234-5678",
    status: "enabled",
  },
  {
    id: 2,
    accountCode: "AC002",
    accountName: "工商银行一般户",
    type: "bank",
    typeName: "银行账户",
    balance: 680000,
    bankName: "工商银行",
    bankAccount: "6222-0000-2345-6789",
    status: "enabled",
  },
  {
    id: 3,
    accountCode: "AC003",
    accountName: "现金账户",
    type: "cash",
    typeName: "现金",
    balance: 25000,
    status: "enabled",
  },
  {
    id: 4,
    accountCode: "AC004",
    accountName: "支付宝账户",
    type: "alipay",
    typeName: "支付宝",
    balance: 86000,
    status: "enabled",
  },
  {
    id: 5,
    accountCode: "AC005",
    accountName: "微信支付账户",
    type: "wechat",
    typeName: "微信支付",
    balance: 52000,
    status: "enabled",
  },
];

export const mockReceivables: any[] = [
  {
    id: 1,
    receivableNo: "AR202601250001",
    sourceType: "sales_delivery",
    sourceNo: "SD202601250001",
    customerId: 1,
    customerName: "上海科技有限公司",
    receivableAmount: 65000,
    settledAmount: 65000,
    balance: 0,
    billingDate: "2026-01-25",
    dueDate: "2026-02-24",
    status: "settled",
  },
  {
    id: 2,
    receivableNo: "AR202603050002",
    sourceType: "sales_delivery",
    sourceNo: "SD202603050002",
    customerId: 2,
    customerName: "北京贸易集团",
    receivableAmount: 89000,
    settledAmount: 50000,
    balance: 39000,
    billingDate: "2026-03-05",
    dueDate: "2026-05-04",
    status: "partial",
  },
  {
    id: 3,
    receivableNo: "AR202604150003",
    sourceType: "sales_delivery",
    sourceNo: "SD202604150003",
    customerId: 3,
    customerName: "广州零售连锁",
    receivableAmount: 42500,
    settledAmount: 42500,
    balance: 0,
    billingDate: "2026-04-15",
    dueDate: "2026-04-30",
    status: "settled",
  },
  {
    id: 4,
    receivableNo: "AR202605200004",
    sourceType: "sales_order",
    sourceNo: "SO202606180004",
    customerId: 4,
    customerName: "深圳创新科技",
    receivableAmount: 59990,
    settledAmount: 0,
    balance: 59990,
    billingDate: "2026-06-18",
    dueDate: "2026-06-18",
    status: "unsettled",
  },
  {
    id: 5,
    receivableNo: "AR202607200005",
    sourceType: "sales_order",
    sourceNo: "SO202607200005",
    customerId: 5,
    customerName: "杭州电商企业",
    receivableAmount: 33800,
    settledAmount: 0,
    balance: 33800,
    billingDate: "2026-07-20",
    dueDate: "2026-08-19",
    status: "unsettled",
  },
];

export const mockPayables: any[] = [
  {
    id: 1,
    payableNo: "AP202601150001",
    sourceType: "purchase_receipt",
    sourceNo: "PR202601150001",
    supplierId: 1,
    supplierName: "深圳电子制造有限公司",
    payableAmount: 63000,
    settledAmount: 63000,
    balance: 0,
    billingDate: "2026-01-15",
    dueDate: "2026-02-14",
    status: "settled",
  },
  {
    id: 2,
    payableNo: "AP202602100002",
    sourceType: "purchase_receipt",
    sourceNo: "PR202602100002",
    supplierId: 2,
    supplierName: "广东办公用品公司",
    payableAmount: 28000,
    settledAmount: 28000,
    balance: 0,
    billingDate: "2026-02-10",
    dueDate: "2026-03-26",
    status: "settled",
  },
  {
    id: 3,
    payableNo: "AP202604200003",
    sourceType: "purchase_receipt",
    sourceNo: "PR202604200003",
    supplierId: 3,
    supplierName: "浙江家具厂",
    payableAmount: 18900,
    settledAmount: 10000,
    balance: 8900,
    billingDate: "2026-04-20",
    dueDate: "2026-04-20",
    status: "partial",
  },
  {
    id: 4,
    payableNo: "AP202607150004",
    sourceType: "purchase_receipt",
    sourceNo: "PR202607150004",
    supplierId: 1,
    supplierName: "深圳电子制造有限公司",
    payableAmount: 54000,
    settledAmount: 0,
    balance: 54000,
    billingDate: "2026-07-15",
    dueDate: "2026-08-14",
    status: "unsettled",
  },
];

export const mockReceipts: any[] = [
  {
    id: 1,
    receiptNo: "RC202602240001",
    customerId: 1,
    customerName: "上海科技有限公司",
    accountId: 1,
    accountName: "招商银行基本户",
    receiptDate: "2026-02-24",
    amount: 65000,
    paymentMethod: "银行转账",
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-02-24 10:00:00",
    details: [
      {
        id: 1,
        receiptId: 1,
        receivableId: 1,
        receivableNo: "AR202601250001",
        receivableAmount: 65000,
        settledAmount: 0,
        thisSettleAmount: 65000,
        balance: 0,
      },
    ],
  },
  {
    id: 2,
    receiptNo: "RC202604100002",
    customerId: 2,
    customerName: "北京贸易集团",
    accountId: 1,
    accountName: "招商银行基本户",
    receiptDate: "2026-04-10",
    amount: 50000,
    paymentMethod: "银行转账",
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-04-10 14:00:00",
    details: [
      {
        id: 2,
        receiptId: 2,
        receivableId: 2,
        receivableNo: "AR202603050002",
        receivableAmount: 89000,
        settledAmount: 0,
        thisSettleAmount: 50000,
        balance: 39000,
      },
    ],
  },
  {
    id: 3,
    receiptNo: "RC202604300003",
    customerId: 3,
    customerName: "广州零售连锁",
    accountId: 3,
    accountName: "现金账户",
    receiptDate: "2026-04-30",
    amount: 42500,
    paymentMethod: "现金",
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-04-30 09:00:00",
    details: [
      {
        id: 3,
        receiptId: 3,
        receivableId: 3,
        receivableNo: "AR202604150003",
        receivableAmount: 42500,
        settledAmount: 0,
        thisSettleAmount: 42500,
        balance: 0,
      },
    ],
  },
];

export const mockPayments: any[] = [
  {
    id: 1,
    paymentNo: "PM202602140001",
    supplierId: 1,
    supplierName: "深圳电子制造有限公司",
    accountId: 1,
    accountName: "招商银行基本户",
    paymentDate: "2026-02-14",
    amount: 63000,
    paymentMethod: "银行转账",
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-02-14 10:00:00",
    details: [
      {
        id: 1,
        paymentId: 1,
        payableId: 1,
        payableNo: "AP202601150001",
        payableAmount: 63000,
        settledAmount: 0,
        thisSettleAmount: 63000,
        balance: 0,
      },
    ],
  },
  {
    id: 2,
    paymentNo: "PM202603260002",
    supplierId: 2,
    supplierName: "广东办公用品公司",
    accountId: 2,
    accountName: "工商银行一般户",
    paymentDate: "2026-03-26",
    amount: 28000,
    paymentMethod: "银行转账",
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-03-26 11:00:00",
    details: [
      {
        id: 2,
        paymentId: 2,
        payableId: 2,
        payableNo: "AP202602100002",
        payableAmount: 28000,
        settledAmount: 0,
        thisSettleAmount: 28000,
        balance: 0,
      },
    ],
  },
  {
    id: 3,
    paymentNo: "PM202605010003",
    supplierId: 3,
    supplierName: "浙江家具厂",
    accountId: 3,
    accountName: "现金账户",
    paymentDate: "2026-05-01",
    amount: 10000,
    paymentMethod: "现金",
    status: "completed",
    createdBy: "admin",
    createdAt: "2026-05-01 10:00:00",
    details: [
      {
        id: 3,
        paymentId: 3,
        payableId: 3,
        payableNo: "AP202604200003",
        payableAmount: 18900,
        settledAmount: 0,
        thisSettleAmount: 10000,
        balance: 8900,
      },
    ],
  },
];

// ========== 报表数据 ==========

export const mockSalesTrend: any[] = (() => {
  const data: any[] = [];
  const months = ["1月", "2月", "3月", "4月", "5月", "6月", "7月"];
  const orderCounts = [12, 18, 25, 20, 28, 35, 30];
  const amounts = [65000, 89000, 120000, 95000, 145000, 180000, 155000];
  const profits = [15000, 22000, 32000, 24000, 38000, 48000, 41000];
  for (let i = 0; i < months.length; i++) {
    data.push({
      date: months[i],
      orderCount: orderCounts[i],
      totalAmount: amounts[i],
      totalProfit: profits[i],
    });
  }
  return data;
})();

export const mockInventorySummary: any[] = [
  {
    productId: 1,
    productCode: "P001",
    productName: "笔记本电脑 Pro 15",
    spec: "15寸/i7/16G/512G",
    unitName: "台",
    beginQuantity: 0,
    beginAmount: 0,
    purchaseQuantity: 25,
    purchaseAmount: 112500,
    saleQuantity: 15,
    saleAmount: 89985,
    endQuantity: 25,
    endAmount: 112500,
  },
  {
    productId: 2,
    productCode: "P002",
    productName: "无线鼠标 M200",
    spec: "2.4G无线/静音",
    unitName: "个",
    beginQuantity: 0,
    beginAmount: 0,
    purchaseQuantity: 200,
    purchaseAmount: 7000,
    saleQuantity: 100,
    saleAmount: 6900,
    endQuantity: 180,
    endAmount: 6300,
  },
  {
    productId: 3,
    productCode: "P003",
    productName: "机械键盘 K870",
    spec: "青轴/RGB背光/87键",
    unitName: "把",
    beginQuantity: 0,
    beginAmount: 0,
    purchaseQuantity: 50,
    purchaseAmount: 9000,
    saleQuantity: 50,
    saleAmount: 16450,
    endQuantity: 85,
    endAmount: 15300,
  },
  {
    productId: 4,
    productCode: "P004",
    productName: "27寸4K显示器",
    spec: "27寸/4K/IPS/Type-C",
    unitName: "台",
    beginQuantity: 0,
    beginAmount: 0,
    purchaseQuantity: 15,
    purchaseAmount: 18000,
    saleQuantity: 10,
    saleAmount: 18990,
    endQuantity: 15,
    endAmount: 18000,
  },
  {
    productId: 6,
    productCode: "P006",
    productName: "A4打印纸 80g",
    spec: "500张/包",
    unitName: "箱",
    beginQuantity: 0,
    beginAmount: 0,
    purchaseQuantity: 100,
    purchaseAmount: 12000,
    saleQuantity: 100,
    saleAmount: 16800,
    endQuantity: 80,
    endAmount: 9600,
  },
];

export const mockSalesRanking: any[] = [
  {
    rank: 1,
    name: "笔记本电脑 Pro 15",
    quantity: 15,
    amount: 89985,
    profit: 22485,
    profitRate: 25,
  },
  { rank: 2, name: "27寸4K显示器", quantity: 10, amount: 18990, profit: 6990, profitRate: 36.8 },
  { rank: 3, name: "USB-C 扩展坞", quantity: 100, amount: 16900, profit: 8400, profitRate: 49.7 },
  { rank: 4, name: "机械键盘 K870", quantity: 50, amount: 16450, profit: 7450, profitRate: 45.3 },
  { rank: 5, name: "A4打印纸 80g", quantity: 100, amount: 16800, profit: 4800, profitRate: 28.6 },
  { rank: 6, name: "无线鼠标 M200", quantity: 100, amount: 6900, profit: 3400, profitRate: 49.3 },
  { rank: 7, name: "办公椅 人体工学", quantity: 10, amount: 7990, profit: 3490, profitRate: 43.7 },
  {
    rank: 8,
    name: "中性笔 0.5mm 黑色",
    quantity: 1000,
    amount: 15000,
    profit: 7000,
    profitRate: 46.7,
  },
];

export const mockDashboardStats: any = {
  totalPurchase: 279500,
  totalSales: 289290,
  totalInventory: 230000,
  totalReceivable: 132790,
  totalPayable: 62900,
  pendingOrders: 8,
  lowStockProducts: 3,
  monthlyGrowth: 15.6,
  orderCount: 168,
};

// ========== 系统管理 ==========

export const mockUsers: any[] = [
  {
    id: 1,
    username: "admin",
    nickname: "系统管理员",
    avatar: "",
    email: "admin@example.com",
    phone: "13800138000",
    roles: ["admin"],
    department: "IT部",
    status: "enabled",
    lastLogin: "2026-08-07 09:00:00",
    createdAt: "2026-01-01 00:00:00",
  },
  {
    id: 2,
    username: "zhangsan",
    nickname: "张三",
    avatar: "",
    email: "zhangsan@example.com",
    phone: "13800138001",
    roles: ["purchaser"],
    department: "采购部",
    status: "enabled",
    lastLogin: "2026-08-06 14:00:00",
    createdAt: "2026-01-05 10:00:00",
  },
  {
    id: 3,
    username: "lisi",
    nickname: "李四",
    avatar: "",
    email: "lisi@example.com",
    phone: "13800138002",
    roles: ["salesperson"],
    department: "销售部",
    status: "enabled",
    lastLogin: "2026-08-05 09:30:00",
    createdAt: "2026-01-08 11:00:00",
  },
  {
    id: 4,
    username: "wangwu",
    nickname: "王五",
    avatar: "",
    email: "wangwu@example.com",
    phone: "13800138003",
    roles: ["warehouse"],
    department: "仓储部",
    status: "enabled",
    lastLogin: "2026-08-04 16:00:00",
    createdAt: "2026-01-10 09:00:00",
  },
  {
    id: 5,
    username: "zhaoliu",
    nickname: "赵六",
    avatar: "",
    email: "zhaoliu@example.com",
    phone: "13800138004",
    roles: ["finance"],
    department: "财务部",
    status: "enabled",
    lastLogin: "2026-08-03 10:00:00",
    createdAt: "2026-01-12 14:00:00",
  },
  {
    id: 6,
    username: "sunqi",
    nickname: "孙七",
    avatar: "",
    email: "sunqi@example.com",
    phone: "13800138005",
    roles: ["viewer"],
    department: "运营部",
    status: "disabled",
    lastLogin: "2026-07-20 11:00:00",
    createdAt: "2026-02-01 09:00:00",
  },
];

export const mockRoles: any[] = [
  {
    id: 1,
    roleCode: "admin",
    roleName: "系统管理员",
    description: "拥有系统全部权限",
    userCount: 1,
    status: "enabled",
    createdAt: "2026-01-01 00:00:00",
  },
  {
    id: 2,
    roleCode: "purchaser",
    roleName: "采购员",
    description: "采购管理相关权限",
    userCount: 1,
    status: "enabled",
    createdAt: "2026-01-01 00:00:00",
  },
  {
    id: 3,
    roleCode: "salesperson",
    roleName: "销售员",
    description: "销售管理相关权限",
    userCount: 1,
    status: "enabled",
    createdAt: "2026-01-01 00:00:00",
  },
  {
    id: 4,
    roleCode: "warehouse",
    roleName: "仓库管理员",
    description: "库存管理相关权限",
    userCount: 1,
    status: "enabled",
    createdAt: "2026-01-01 00:00:00",
  },
  {
    id: 5,
    roleCode: "finance",
    roleName: "财务员",
    description: "资金管理相关权限",
    userCount: 1,
    status: "enabled",
    createdAt: "2026-01-01 00:00:00",
  },
  {
    id: 6,
    roleCode: "viewer",
    roleName: "查看者",
    description: "仅查看权限",
    userCount: 1,
    status: "enabled",
    createdAt: "2026-01-01 00:00:00",
  },
];

export const mockOperationLogs: any[] = [
  {
    id: 1,
    username: "admin",
    module: "采购管理",
    action: "审核采购订单",
    description: "审核采购订单 PO202603200003",
    ip: "192.168.1.100",
    createdAt: "2026-07-20 14:30:00",
  },
  {
    id: 2,
    username: "admin",
    module: "基础资料",
    action: "修改商品",
    description: "修改商品 笔记本电脑 Pro 15",
    ip: "192.168.1.100",
    createdAt: "2026-07-20 14:00:00",
  },
  {
    id: 3,
    username: "zhangsan",
    module: "采购管理",
    action: "新增采购订单",
    description: "新增采购订单 PO202607100006",
    ip: "192.168.1.101",
    createdAt: "2026-07-10 14:00:00",
  },
  {
    id: 4,
    username: "lisi",
    module: "销售管理",
    action: "新增销售订单",
    description: "新增销售订单 SO202607200005",
    ip: "192.168.1.102",
    createdAt: "2026-07-20 10:00:00",
  },
  {
    id: 5,
    username: "wangwu",
    module: "库存管理",
    action: "库存盘点",
    description: "创建盘点单 ST202607010003",
    ip: "192.168.1.103",
    createdAt: "2026-07-01 09:00:00",
  },
  {
    id: 6,
    username: "zhaoliu",
    module: "资金管理",
    action: "审核收款单",
    description: "审核收款单 RC202604300003",
    ip: "192.168.1.104",
    createdAt: "2026-04-30 09:00:00",
  },
  {
    id: 7,
    username: "admin",
    module: "系统管理",
    action: "新增用户",
    description: "新增用户 孙七",
    ip: "192.168.1.100",
    createdAt: "2026-02-01 09:00:00",
  },
  {
    id: 8,
    username: "admin",
    module: "库存管理",
    action: "库存调拨",
    description: "审核调拨单 TR202605010002",
    ip: "192.168.1.100",
    createdAt: "2026-05-01 11:00:00",
  },
];
